export const ProboPredictionWidgetApiCall = async ({
    url,
    eventId,
    token,
}: {
    url: string;
    eventId: number;
    token?: string;
}) => {
    const response = await fetch(`${url}?eventId=${eventId}`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });

    const data = await response.json();

    return data;
};

export const ProboProductWidgetApiCall = async ({
    url,
    eventId,
}: {
    url: string;
    eventId: number;
}) => {
    const response = await fetch(`${url}/${eventId}`, {
        method: "GET",
        headers: {
            "x-device-os": "ANDROID",
            "x-version-name": "10",
        },
    });

    const data = await response.json();

    return data;
};
